// Menu articolo del preventivo: risultati caricati a pagine mentre si scorre
// [sc-48920]. Spec: docs/superpowers/specs/2026-09-29-sc-48920-ricerca-articolo-design.md §5.1

/** Articoli chiesti a item/get-all per ogni pagina del menu. */
export const PAGINA_RICERCA = 30;

/** Accoda una pagina alle voci già caricate, senza doppioni (per id). */
export function unisciPagina(attuali, nuovi) {
  const visti = new Set((attuali || []).map((i) => i?.id));
  return [
    ...(attuali || []),
    ...(nuovi || []).filter((i) => !visti.has(i?.id)),
  ];
}

/** Ci sono altre pagine da caricare? */
export function altrePagine(pagination) {
  const pagina = Number(pagination?.currentPage) || 0;
  const totali = Number(pagination?.totalPages) || 0;
  return pagina > 0 && pagina < totali;
}

/** Riga in fondo al menu: quanti ne vedi su quanti ce ne sono. */
export function testoConteggio(caricati, totale) {
  const n = Number(caricati) || 0;
  const tot = Number(totale) || 0;
  if (!tot) return "";
  if (n < tot) return `${n} di ${tot} · scorri per altri`;
  return tot === 1 ? "1 risultato" : `${tot} risultati`;
}
